import { ApplicationDetails, ApplicationInspection } from "../Components/Home/ApplicationDetails.types";
import { DateFormat, Tag, TagColumnFilter } from "@fdoh/health-react";
import { Link, useHistory } from "react-router-dom";
import { CellProps } from "react-table";
import IconTrash from "../../icons/IconTrash";
import IconEdit from "../../icons/IconEdit";
import { ColumnSetting } from "../../components/IndexCard.types";
import IconFileInfo from "../../icons/IconFileInfo";
import IconPrinter from "../../icons/IconPrinter";
import { IconDownload } from "@tabler/icons";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";

export type UserFormProps = {
    id: string;
    returnPath: string;
      title: string;
      applicationInspectionId?: number;
      applicationId?: number;
  
    // schema: AnyObjectSchema | Lazy<any, unknown>;
      values?: UserList;
    action: "post" | "put";
  };
  

export type UserList = {
  userSecurityId:number;
  userClaimsObjectId:string;
  userName:string;
  lastName:string;
  firstName:string;
  roleId:Number;
  email:string;
  isActive:boolean;
  dateUpdated:Date | string;
  updatedby: string;

}
export type CountyEmailData = {
  key: string;
  value: string;
};

export const Columns = [
  {
    Header: "User ID",
    accessor: (row: UserList) => row.userSecurityId,
    
  },

  {
    Header: "User Object ID",
    accessor: (row: UserList) => row.userClaimsObjectId,
    
  },
  {
      Header: "User Name",
      accessor: (row: UserList) => row.userName,
      
  },
  {
    Header: "Last Name",
    accessor: (row: UserList) => row.lastName,
    
},
{
  Header: "First Name",
  accessor: (row: UserList) => row.firstName,
  
},
  {
      Header: "Email",
      Cell: ({ row }: { row: { original: UserList } }) => (
        <a href={`mailto:${row.original.email}`}>{row.original.email}</a>
      ),
      
  },

  {
    Header: "Date Updated",
    accessor: (row: UserList) => new Date(row.dateUpdated ?? 0),
    Cell: ({ value }: { value?: Date }) =>
        value ? new Date(value).toLocaleDateString() : null,
    sortType: "datetime",
    
},
{
  Header: "Updated By",
  accessor: (row: UserList) => row.updatedby,
  
},
{
  Header: "Actions",
  id: "userform",
  accessor: (row: UserList) =>
  (
      <>
          <div className="row">
              <div className="col-sm-4">
                  <a title="Open"  href={`/userForm/${row.userSecurityId}`}  >
                  
                      <IconEdit />
                  </a>
              </div>
            
          </div>                
      </>
  ),
},
]


